<ion-content class="invite-sheet">
  <h3 class="title">{{title}}</h3>

  <div *ngIf="view === 'link'">
    <div class="input-row">
      <ion-input [value]="inviteLink" readonly></ion-input>
      <ion-button fill="fill" (click)="copy()" size="large">
        <ion-icon name="copy"></ion-icon>
      </ion-button>
    </div>

    <div class="btn-row">
      <ion-button *ngIf="canShare" expand="block" color="primary" (click)="share()">Share</ion-button>
      <ion-button *ngIf="!canShare" expand="block" color="primary" (click)="copy()">Copy</ion-button>
      <ion-button expand="block" fill="outline" (click)="close()">Close</ion-button>
    </div>
  </div>

  <div *ngIf="view === 'sheet'">
    <div class="option-grid">
      <ion-button *ngFor="let option of invitationOptions; trackBy: trackByOptionId" fill="clear" class="option-button"
        (click)="selectOption(option.id)">
        <div class="option-content">
          <ion-icon [name]="option.icon" class="option-icon"></ion-icon>
          <span class="option-text">{{ option.text }}</span>
        </div>
      </ion-button>
    </div>
  </div>
</ion-content>